import { render, staticRenderFns } from "./disbursed.vue?vue&type=template&id=06755706&"
import script from "./disbursed.vue?vue&type=script&lang=js&"
export * from "./disbursed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports